<div class="gs-modal">
    <div class="gs-modal__content">
        <div class="text-center">
            <h5 class="mb-3">{{initialState.fromcampaign ? "Also want to delete all stories linked to this campaign?" : "Do you want delete this campaign?" }}</h5>
            <div class="btn btn-pink mx-1"(click)="deletecampaign()">No</div>
            <a href="javascript:void(0)" (click)="deletecampaignandStory()" class="btn btn-gray-light mx-1">Yes</a>
        </div>
    </div>
</div>
